export const checkCanvasState = (canvas) => {
  if (!canvas) {
    console.log("Canvas does not exist.");
    return;
  }

  const context = canvas.getContext("2d");

  try {
    const imageData = context.getImageData(
      0,
      0,
      canvas.width,
      canvas.height
    ).data;

    // Check if all pixels are fully transparent
    const isEmpty = Array.from(imageData).every((_, index) => {
      // Check the alpha channel (4th value in each pixel)
      return (index + 1) % 4 === 0 && imageData[index] === 0;
    });

    if (isEmpty) {
      console.log("Canvas is empty.");
    } else {
      console.log(
        "Canvas contains an image. Width:",
        canvas.width,
        "Height:",
        canvas.height
      );
    }
  } catch (error) {
    console.error("Failed to read canvas data. Error:", error);
  }
};
